import React, { useState } from 'react';
import { HStack } from '@chakra-ui/react';
import { useColors } from '../../../components/common/Color';
import LeftFormSection from './Left/Left_Details';
import RightFormSection from './Right/Right_details';

import HeaderSection from '../../../components/common/Header/HeaderSection';

function Student_profile() {
  const colors = useColors();


  return (
    <div>
      {/* Use the new HeaderSection component */}
      <HeaderSection
        title="Profile" 
        breadcrumb={["Dashboard", "Profile"]} 
      />

      <HStack align="start"   gap="0" p={6}>
        <LeftFormSection colors={colors} />
        <RightFormSection colors={colors} />


      </HStack>
    </div>
  );
}

export default Student_profile;
